import React, { useState, useEffect, useRef } from 'react';
import { InputLabel } from '@material-ui/core';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import debounce from 'lodash.debounce';

export default function TextEditor(props) {
  const [contents, setContents] = useState(props.setContents || '');
  const prevContentRef = useRef(contents);

  const buttons = [
    ['undo', 'redo'],
    ['font', 'fontSize', 'formatBlock'],
    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
    ['removeFormat'],
    ['fontColor', 'hiliteColor'],
    ['outdent', 'indent'],
    ['align', 'horizontalRule', 'list', 'table'],
    ['link', 'image'],
    ['showBlocks', 'preview', 'fullScreen', 'codeView'],
  ];

  const options = {
    height: props.height || 300,
    flex: 3,
    attributesWhitelist: {
      all: 'id', // Apply to all tags
    },
    ...{ buttonList: buttons },
  };

  //for json
  const formatValue = (value) => {
    //recursive formatting contatenated objects inside object e.g. dates with year, month, day
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        return value.map((item) => formatValue(item)).join(';<br>');
      } else {
        //adding formats
        return Object.entries(value)
          .map(([key, val]) => `<br>${key}=${formatValue(val)}`)
          .join('');
      }
    } else {
      return value;
    }
  };

  //for json
  const formatArray = (arrayName, array) => {
    //formatting of key-data pairs
    const formattedArray = array
      .map((item) => {
        return formatValue(item);
      })
      .map((formattedObject) => {
        return `${formattedObject}`;
      })
      .join('');

    //returning values with format
    return `<p><b>${arrayName}=</b>${formattedArray}</p>`;
  };

  const handleChange = debounce((content) => {
    let dataWithLineBreaks = content;

    const processContent = async () => {
      if (props.format === 'JSON') {
        if (content.includes('&amp;')) {
          //usually used in GET method

          //replacing "&" with new line (cleans up json)
          dataWithLineBreaks = content.replace(/&amp;/g, '<br>');

          //adding format. will bold the field name.
          const lines = dataWithLineBreaks.split('<br>');
          const formattedLines = lines.map((line) => {
            const [key, value] = line.split('=');
            return `<b>${key}</b> = ${value}`;
          });
          dataWithLineBreaks = `<p>${formattedLines.join('<br>')}</p>`;
        } else if (content.includes('{') && content.includes('}')) {
          // //usually used in POST method
          try {
            //remove initial p tag to enable parsing json
            const cleanData = content.replace(/<\/?p>/g, '');
            const data = JSON.parse(cleanData);

            let cleanUp = '';

            //get key-data pairs
            for (const key in data) {
              cleanUp += formatArray(key, [data[key]]);
            }
            dataWithLineBreaks = cleanUp;
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        }
      }

      if (dataWithLineBreaks !== prevContentRef.current) {
        setContents(dataWithLineBreaks);
        props.onChange(dataWithLineBreaks);
        prevContentRef.current = dataWithLineBreaks;
      }
    };

    processContent();
  }, 500);

  const disabled = props.disable || props.disabled || props.readOnly || props.readonly;
  return (
    <>
      <InputLabel
        shrink
        style={{ marginBottom: 5 }}
        required={props.required}
        error={props.error}
      >
        {props.label}
      </InputLabel>
      <SunEditor
        setOptions={options}
        name={props.name}
        enableToolbar={props.enableToolbar}
        setContents={props.value}
        readOnly={props.readOnly}
        onChange={handleChange}
        disable={disabled}
        showToolbar={!disabled}
        rows={props.rows}
      />
    </>
  );
}
